import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: { inputText: string; key?: string }): any[] {
    // Pipe filter take 2 parameters,
    // items = list of item to filter,
    //  searchText object with inputText from the input,
    // and key if the items is a list of object, so we need to determine wich property to filter
    if (!items) {
      return [];
    }
    if (!searchText.inputText) {
      return items;
    }
    const key = searchText.key;
    const inputText = searchText.inputText.toLowerCase();

    return items.filter(item => {
      if (key) {
        return item[key].toLowerCase().includes(inputText);
      } else {
        return item.toLowerCase().includes(inputText);
      }
    });
  }
}
